import { ArrowBack } from '@material-ui/icons';
import { InlineWidget, useCalendlyEventListener } from 'react-calendly';
import { Button } from 'src/shared-components';

type CuratedEngagementProps = {
  goBack: () => void;
  onScheduled: () => void;
};

// TODO: Move to constants
const TANDRA_CALENDLY_URL = 'https://calendly.com/tandra-le/30min';

const CuratedEngagement = ({ goBack, onScheduled: onEventScheduled }: CuratedEngagementProps) => {
  useCalendlyEventListener({ onEventScheduled });

  return (
    <div className="p-4 flex flex-col w-[46rem]">
      <div className="flex space-x-3 items-center mb-7">
        <Button color="gray" onClick={goBack} className="space-x-1">
          <ArrowBack fontSize="small" />
          <span>Back</span>
        </Button>
      </div>
      <div className="flex flex-col">
        <h2 className="font-bold text-2xl">Tell us your goals. We&apos;ll build your Huddle.</h2>
        <div className="flex flex-wrap items-center text-xl text-huddleBlack">
          <span>Huddle member</span>
          <img
            className="mx-1 rounded-full h-8 w-8 border-2 border-orange-300"
            src="/images/tandra.jpeg"
            alt="Image of Tandra"
          />
          <span>Tandra is ready to chat and hear more</span>
          <span>about what you need.</span>
        </div>
        <InlineWidget
          url={TANDRA_CALENDLY_URL}
          pageSettings={{ hideEventTypeDetails: true, hideLandingPageDetails: true }}
        />
      </div>
    </div>
  );
};

export default CuratedEngagement;
